export const ACTION_TYPES = {
  START_LOADING: "START_LOADING",
  STOP_LOADING: "STOP_LOADING"
};
